<section class="why-choose" [dir]="lang.getDir()">
  <div class="container">
    <h2 class="section-title animate-slide-in">{{ 'why.title' | translate }}</h2>

    <div class="features-grid">
      <div class="feature-item animate-fade-in" *ngFor="let feature of features">
        <div class="icon">{{ feature.icon }}</div>
        <h3 class="feature-title">{{ feature.title | translate }}</h3>
        <p class="feature-desc">{{ feature.desc | translate }}</p>
      </div>
    </div>
  </div>
</section>
